/**
 * Drawer focus helpers — pure, testable without DOM environment.
 */

export const DRAWER_FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'

export function nextFocusIndex(
  current: number,
  count: number,
  shiftKey: boolean,
): number {
  if (count <= 0) return 0
  if (shiftKey) return current <= 0 ? count - 1 : current - 1
  return current >= count - 1 ? 0 : current + 1
}
